/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';

import { MenuItem, MenuProps } from '@mui/material';
import Menu from '@mui/material/Menu';
import withStyles from '@mui/styles/withStyles';

export const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    width: 100,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
})(
  memo<MenuProps>(props => (
    <Menu
      elevation={0}
      anchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  )),
);

// eslint-disable-next-line react-memo/require-memo
export const StyledMenuItem = withStyles(() => ({
  root: {
    '&.MuiButtonBase-root': {
      justifyContent: 'center',
      paddingTop: 0,
      paddingBottom: 0,
    },
    '&:focus': {},
    '& .flag': {
      fontSize: '2em',
    },
    '&.MuiButtonBase-root.selected': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
    '&.active': {
      background: '#bbb',
    },
  },
}))(MenuItem);
